// extracted by mini-css-extract-plugin
module.exports = {"SecondaryBtn":"Button_SecondaryBtn__LVNW7","PrimaryBtn":"Button_PrimaryBtn__1UGgm","RippleEffectBtn":"Button_RippleEffectBtn__jpkMO"};